var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.016 20.8001H11.984C11.992 20.7921 12 20.7761 12 20.7681C12 20.7761 12.008 20.7921 12.016 20.8001Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6.39995H9.60001C9.16001 6.39995 8.80001 6.03995 8.80001 5.59995C8.80001 5.15995 9.16001 4.79995 9.60001 4.79995H14.4C14.84 4.79995 15.2 5.15995 15.2 5.59995C15.2 6.03995 14.84 6.39995 14.4 6.39995ZM3.20001 3.19995V19.2C3.20001 20.08 3.91201 20.7999 4.80001 20.7999H11.608C11.344 20.048 11.2 19.24 11.2 18.4C11.2 17.68 11.304 16.992 11.496 16.344C12.384 13.368 15.128 11.2 18.4 11.2C19.248 11.2 20.048 11.344 20.8 11.608V3.19995H3.20001Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.7681C12 20.7761 12.008 20.7921 12.016 20.8001H11.984C11.992 20.7921 12 20.7761 12 20.7681Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 13.344C20.072 12.992 19.264 12.8 18.4 12.8C15.856 12.8 13.72 14.488 13.032 16.8C12.88 17.304 12.8 17.84 12.8 18.4C12.8 19.264 12.992 20.072 13.344 20.8C14.24 22.696 16.16 24 18.4 24C21.496 24 24 21.496 24 18.4C24 16.16 22.696 14.24 20.8 13.344ZM21.368 17.368L20.8 17.936L18.168 20.568C18.008 20.72 17.808 20.8 17.6 20.8C17.392 20.8 17.192 20.72 17.032 20.568L15.432 18.968C15.12 18.656 15.12 18.144 15.432 17.832C15.744 17.52 16.256 17.52 16.568 17.832L17.6 18.872L19.664 16.8L20.232 16.232C20.392 16.08 20.592 16 20.8 16C21.008 16 21.208 16.08 21.368 16.232C21.68 16.544 21.68 17.056 21.368 17.368Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentIcon);
export default __webpack_public_path__ + "static/media/shipment-icon.fe476eb1bceba6ea61dafb10069dc836.svg";
export { ForwardRef as ReactComponent };